module.exports = __webpack_public_path__ + "img/partner_logo10.a5b6fdbf.png";